// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mq-c";
export var backButton = "_mq-4";
export var backIcon = "_mq-5";
export var chevronShortcut = "_mq-6";
export var container = "_mq-1";
export var editor = "_mq-8";
export var editorWrapper = "_mq-7";
export var prefix = "_mq-2";
export var searchIcon = "_mq-3";
export var suffix = "_mq-9";
export var suffixContent = "_mq-a";
export var suffixText = "_mq-b";
export var wrapper = "_mq-0";